// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2M5Qf","signatureButtonsRight":"ModalSign_signatureButtonsRight__235Zp"};